<template>
  <tr>
    <td>
      <table class="table is-fullwidth">
        <tbody>
          <tr v-for="(item_key, key) in item_keys" :key="key">
            <td>
              <strong>{{ headings[key] + ':' }}</strong>
            </td>
            <table-cell-component
              class="has-text-right"
              :bus="bus"
              :cell_item="getItemForKey(item_key)">
            </table-cell-component>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
<script>
  import TableCellComponent from '@/components/layout/table/TableCellComponent'
  import { getDetailDisplayContext } from '@/utility/utility_functions'

  export default {
    name: 'table-row-compact-component',
    props: {
      item: {
        type: Object
      },
      item_keys: {
        type: Array
      },
      display_spec: {
        type: Array
      },
      headings: {
        type: Array
      },
      bus: {
        type: Object,
        required: true
      }
    },
    components: {
      TableCellComponent
    },
    computed: {
      displayContext: function () {
        return getDetailDisplayContext(this.item, this.display_spec)
      }
    },
    methods: {
      getItemForKey (key) {
        return this.displayContext.find(i => i.item_key === key)
      },
      findRowForChild (element) {
        if (this.findChild(element, this.$children)) {
          this.bus.$emit('foundRowForChild', { child: element, row: this })
        }
      },
      findChild (element, children) {
        let found = false
        for (let child of children) {
          if (child === element) {
            return true
          } else {
            found = this.findChild(element, child.$children)
          }
        }
        return found
      }
    },
    created () {
      this.bus.$on('findRowForChild', this.findRowForChild)
    }
  }
</script>
